export default __webpack_public_path__ + "static/media/ColdCharging.02d85c4b.svg";